export default "__VITE_PUBLIC_ASSET__e83b3e15__"